import { Navigate, Outlet, useLocation } from "react-router";

import { Page } from "@/components/page";
import { SectionLayout } from "@/components/section-layout";
import { DOC_PAGES, docsPath, docsStartPath } from "@/lib/docs-pages";

import { useDocsContent } from "./content";
import { DOC_PAGE_PARTS } from "./pages";

export { DocPage } from "./doc-page";

/**
 * The docs, for everyone signed in, a layout route under `/docs`: one page
 * per topic, in the order a newcomer reads them (connecting Claude, what to
 * ask, the tools, what the connector cannot do, privacy, questions and
 * problems), with their own navigation as Settings has: a column beside the
 * page when the area is wide enough, tabs above it otherwise. The tabs wrap
 * rather than scroll, so every page stays in sight. The text follows the
 * dashboard's language and switches with it.
 */
export function DocsLayout() {
  const content = useDocsContent();
  const groups = [
    {
      items: DOC_PAGES.map((page) => ({
        to: docsPath(page),
        label: content.pages[page],
        icon: DOC_PAGE_PARTS[page].icon,
      })),
    },
  ];

  return (
    <Page title={content.page.title} description={content.page.description}>
      <SectionLayout label={content.page.contentsLabel} groups={groups} wrapTabs>
        <Outlet />
      </SectionLayout>
    </Page>
  );
}

/**
 * `/docs` itself: on to the first page, or, for a link from when the docs
 * were one long page (`/docs#privacy-and-data`), to the page that now holds
 * that section.
 */
export function DocsStart() {
  const { hash } = useLocation();
  return <Navigate to={docsStartPath(hash)} replace />;
}
